import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Router } from "@angular/router";
import { URLUtils } from '../../urlUtils';
import { Utils } from '../../utils';

@Component({
    selector: 'app-firmname-login',
    templateUrl: './firmname-login.component.html',
    styleUrls: ['./firmname-login.component.css'],
    standalone: false
})
export class FirmnameLoginComponent implements OnInit {
  
  @Input('parentData') parentData: any;
  @Output() event = new EventEmitter<any>();
  
  submitted: boolean = false;
  firms: any[] = [];
  showPassword = false;
  showTC = false;

  myForm = this.formBuilder.group({
    firmname: ['select', [Validators.required]],
    password: ['', [Validators.required]]
  })

  constructor(private formBuilder: FormBuilder,
              private httpservice: HttpService,
              private router: Router) { }

  ngOnInit() {
    this.firms = this.parentData['firms']
  }

  get f() { return this.myForm.controls; }

  cancelml() {
    this.event.emit({"msg":"firm-close"})
  }

  initSession(resp: any){
    if (resp['data']['account_status'] != null) {
      if (resp['data']['account_status'] == 'disable') {
        $("#id_alert").text("Your acccount has disabled, Please contact admin")
        return
      }
    }
    if (resp['data']['password_mode'] != null) {
      if (resp['data']['password_mode'] == 'reset') {
        // Let login component handle password reset.
        let d = resp['data']
        d['enteredPwd'] = this.myForm.value['password']
        d['firmId'] = this.myForm.value['firmname']
        this.event.emit({"msg":'resetpwd', "data": d})
      } else {
        if (resp['data']['plan'].toLowerCase() == Utils.productName) {
          localStorage.setItem('plan', resp['data']['plan'].toUpperCase())
        }
        else {
          $("#id_alert").text("Account not found")
          return
        }
        if(resp['data']['id'] != null) {
          localStorage.setItem('user_id', resp['data']['id'])
        }
        else {
          localStorage.removeItem('user_id')
        }
        localStorage.setItem('TOKEN', resp['token'])
        localStorage.setItem('name', resp['data']['name'])
        localStorage.setItem('role', resp['data']['role'])
        localStorage.setItem('isadmin', resp['data']['admin'])
        localStorage.setItem('jid', resp['data']['uid'])
        localStorage.setItem('firm_name', resp['data']['firm_name'])
        localStorage.setItem('is_marketplace', resp['data']['is_marketplace'])
        localStorage.setItem('isPaidSub', JSON.stringify(resp['data']['subscription']['is_active'])); //Storing groups in localStorage

        localStorage.setItem('user_allowed', JSON.stringify(resp['data'].user_allowed));
        localStorage.setItem('AAM_email', JSON.stringify(resp['data'].email)); 
        if (resp['data']['regswatch_agreement'] != undefined && !resp['data']['regswatch_agreement']) {
          this.openAgreement()
          //console.log(resp['data'])
          return
        }
        if (resp['data']['firms'] && Array.isArray(resp['data']['firms'])) {
  // store canonical array under 'user_firms'
  localStorage.setItem('user_firms', JSON.stringify(resp['data']['firms']));
} else {
  // defensively clear old data if none present
  localStorage.removeItem('user_firms');
}
        this.router.navigate(['/grid'])
      }
    }
  }

  login(data:any) {
    this.httpservice.sendPostRequest(URLUtils.login, data).subscribe(
      (resp:any) => {
        if(!resp['error']){
          if (resp['data']['plan'].toLowerCase() == Utils.productName){ 
            localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups'])); //Storing groups in localStorage
            this.initSession(resp)
          } 
        } else {
          if (resp['plan'] != undefined && resp['plan'] != Utils.productName){
              $("#id_alert").text("Account not found")
          } else{
              $("#id_alert").text(resp['msg'])
          }
        }
      }
    )
  }
   openAgreement(): void {
    this.showTC = true;
  }
  closeAgreement(): void {
    this.showTC = false;
  }
  agree(): void {
    this.showTC = false;
	this.httpservice.sendPostRequest(URLUtils.aggrementPdfFile, {}).subscribe((res:any) => {
	  if (res.error == false) {
		this.router.navigate(['/grid']);
	  }

	})
  }
   

  onSubmit() {
    this.submitted = true

    console.log('formval',this.myForm.value);
    console.log('parentData',this.parentData);

    if (this.myForm.invalid) { return; }
    let payload: any = {"email": this.parentData['email']}
    payload['userid'] = this.myForm.value['firmname']
    payload['password'] = this.myForm.value['password']
    this.login(payload)
  }

}
